import React from 'react'

export default function Header() {
  return (
    <header className="App-header">
            <h1>Shopping Cart</h1>
          </header>
  )
}
